export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      title: true,
      name: 'Menu',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Maintenance',
      url: '/maintenance',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Users',
          url: '/maintenance/user-list',
          icon: 'icon-docs'
        }      
      ]
    },
    {
      name: 'Reports',
      url: '/report',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Tracking Sheet',
          url: '/report/tracking-sheet',
          icon: 'icon-docs'
        }
        // ,
        // {
        //   name: 'No Strike List',
        //   url: '/report/no-strike-list',
        //   icon: 'icon-docs'
        // }
      ]
    },
    {
      name: 'Utility',
      url: '/utility',
      icon: 'icon-wrench',
      children: [
        {
          name: 'Convert NSL to KML',
          url: '/utility/nsl2kml',
          icon: 'icon-docs'
        }//,
        // {
        //   name: 'Extract PAX to CSV',
        //   url: '/utility/pax2csv',
        //   icon: 'icon-docs'
        // }        
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav_admin.js